'use client'

import {useTranslate} from '@local/hooks'
import {LinkInput} from '@local/types'
import {PrivateRetreatSlideout} from '../privateRetreat/PrivateRetreatSlideout'
import {Button, EnquireForm} from '@local/ui/components'
import type {RetreatQuestion} from '../privateRetreat/types'
import {cx} from '@local/utils/cx'
import {useState} from 'react'

const DEFAULT_JOURNEY_HREF = 'https://journey.kaer.co'

interface Props {
	className?: string;
	withPrivateRetreat: boolean;
	primaryCta?: LinkInput;
	contactForm: {
		listID: string;
		successText: string;
		description: string;
		successTitle: string;
		retreatList: Array<{ label: string; id: string; value: string }>;
	};
	organizeRetreatQuestions: {
		listID: string;
		successText: string;
		successTitle: string;
		questions: Array<RetreatQuestion>;
	};
}

export const FormSlideout = ({
	className,
	withPrivateRetreat,
	primaryCta,
	contactForm,
	organizeRetreatQuestions,
}: Props) => {
	const locale = useTranslate()
	const [isPrivateOpen, setIsPrivateOpen] = useState<boolean>(false)
	const [isContactOpen, setIsContactOpen] = useState<boolean>(false)
	return (
		<>
			<div
				className={cx(
					'mx-auto flex flex-col lg:flex-row justify-center gap-10 lg:gutter-gap-1 lg:pb-70',
					className,
				)}>
				{withPrivateRetreat && (
					<Button
						small
						className='w-full lg:span-w-3'
						variant='secondary-transparent'
						onClick={() => setIsPrivateOpen(true)}
						border>
						{locale('Start Planning')}
					</Button>
				)}
				{/* <Button
					small
					className='w-full lg:span-w-3'
					onClick={() => setIsContactOpen(true)}
					variant='primary'>
					{locale('Contact')}
				</Button> */}
				{primaryCta?.url
					? (
						<Button
							small
							border
							variant='primary'
							className='w-full lg:span-w-3'
							linkInput={primaryCta}
							label={primaryCta.label} />
					)
					: (
						<Button
							small
							border
							variant='primary'
							className='w-full lg:span-w-3'
							href={DEFAULT_JOURNEY_HREF}>
							{locale('Begin your journey →')}
						</Button>
					)}
			</div>

			{organizeRetreatQuestions && withPrivateRetreat && (
				<PrivateRetreatSlideout
					{...organizeRetreatQuestions}
					newsletterOnSubmit={false}
					isOpen={isPrivateOpen}
					onClickClose={() => setIsPrivateOpen(false)} />
			)}
			{contactForm && (
				<EnquireForm
					title='Register'
					{...contactForm}
					isOpen={isContactOpen}
					onClickClose={() => setIsContactOpen(false)} />
			)}
		</>
	)
}
